import $, { data } from "jquery";
import lightGallery from "lightgallery";
import Toastify from "toastify-js";

//Orders list
$(".order-detail .files-slider").each((_, slider) => {
  if ($(slider).find("img").length > 8) {
    $(slider).slick({
      // Параметры настройки слайдера
      dots: false, // Показать точки навигации
      infinite: false, // Зацикливание слайдов
      speed: 500, // Скорость перехода
      slidesToShow: 8.5, // Количество слайдов для показа
      slidesToScroll: 1, // Количество слайдов для прокрутки
      arrows: true,
      nextArrow: `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="slick-next"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M13 18l6 -6" />
        <path d="M13 6l6 6" />
      </svg>`,
      prevArrow: `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="slick-prev"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M5 12l6 6" />
        <path d="M5 12l6 -6" />
      </svg>`,
    });

    lightGallery(document.getElementById("lightGallery"), {
      selector: ".slick-slide div > div[data-src]",
      speed: 500,
    });
  } else {
    $(".order-detail .files-slider img").addClass("less_than_3");
    lightGallery(document.getElementById("lightGallery"), {
      selector: "div[data-src]",
      speed: 500,
    });
  }
});


//Order response logic

function removeResponse() {
  const responseId = $('.response__remove-button').data("id");
  const token = $("#csrf-token").val()

  fetch(`/response/${responseId}`, {
    method: "DELETE",
    headers: {
        'X-CSRF-TOKEN': token,
        'Accept': 'application/json'
    }
  }).then(data => {
    if(data.status === 200) {
      // location.reload();
    }
  })
}

$('.response__remove-button').on("click", removeResponse)

$('#warningModal').on('show.bs.modal', function (event) {
  // `event.relatedTarget` — элемент, который открыл модалку
  const button = $(event.relatedTarget);
  const responseId = button.data('id');

  // Записываем ID в кнопку удаления внутри модалки
  $(this).find('.response__remove-button').data('id', responseId);
});


$(".order-detail__response-button").on("click", function() {
  $(".response__form").show();
});

$("#orderResponse").validate({
  rules: {
    message: {
      required: true,
      minlength: 3,
    },
    price: {
      required: false,
      digits: true,
    },
    measure: {
      required: true,
    },
  },
  messages: {
    message: {
      required: "Введите сообщение которое увидит автор заказа",
      minlength: "Сообщение должно содержать как минимум 3 символа",
    },
    price: "Цена заказа должна быть указана в цифрах либо не указана вовсе",
    measure: {
      required: "Выберите за что указываете цену, например (За услугу)",
    },
  },
});

$("#orderResponse").on("input change", "input, textarea, select", function () {
  const isValid = $("#orderResponse").valid();
  $(".order-detail__send-response").prop("disabled", !isValid);
});

$(".order-detail__send-response").on("click", function () {
  const formElement = document.querySelector("#orderResponse");
  const formData = new FormData(formElement);

  fetch("/response", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        Toastify({
          text: "Не удалось добавить отклик",
          gravity: "bottom", // `top` or `bottom`
          position: "right",
          duration: 3000,
        }).showToast();

        throw new Error(response);
      }
    })
    .then((data) => {
      // location.reload();
    });
});